import React from 'react';

const SearchBar = ({keyword,setKeyword}) => {
  const BarStyling = {background:"#F2F1F9", border:"none", padding:"0.7rem", margin:"10px 20px"};
  return (
    <input 
     style={BarStyling}
     className="search-bar"
     key="random1"
     value={keyword}
     placeholder={"Search Clients"}
     onChange={(e) => setKeyword(e.target.value)}
    />
  );
}

export default SearchBar